import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 20px;
  .routeLine {
    display: flex;
    justify-content: center;
    margin-right: 75px;
    @media (max-width: 730px) {
      display: none;
    }
   }
  .dot {
    z-index: 10;
  }
  .widgetLine {
    z-index: -1;
    position: absolute;
    height: calc(100% - 224px);
    width: 2px;
    background-color: #d2dae4;
    top: 93px;
    @media (max-width: 1400px) {
        height: calc(100% - 210px);
        top: 86px;
    }
  }
`

export const WidgetContainer = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
  width: 623px;
  height: 160px;
  border-top-left-radius: 100px;
  border-bottom-left-radius: 100px;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);
  background-color: ${props => (props.selected ? '#000' : '#fff')};
  @media (max-width: 1400px) {
    width: 494px;
    height: 147px;
  }
  @media (max-width: 1200px) {
    width: 623px;
    height: 160px;
  }
  @media (max-width: 730px) {
    display: flex;
    flex-flow: row-reverse;
    width: 100%;
    height: 130px;
    border-radius: 0;
    justify-content: space-evenly;
  }
  @media (max-width: 500px) {
    justify-content: flex-end;
  }
  button {
    background: none;
    border: none;
    outline: none;
    cursor: pointer;
    @media (max-width: 730px) {
      align-self: end;
      margin-top: 5px;
      position: absolute;
      right: 0;      
    }
  }
  .starSvg {
    :hover {
      fill: #933EC5;
    }
    margin-left: 34px;
    fill: #fff;
    transition: fill .4s ease;
   @media (max-width: 730px) {
      margin-right: 15px;
      width: 35px;
      height: 35px;
      margin-left: 0;
    }
  }
  .infoBlock {
    display: flex;
    flex-direction: column;
    width: 300px;
    margin-left: 20px;
    font-size: 20px;
    line-height: 1.5;
    letter-spacing: 2px;
    font-family: StolzlMedium, serif;
    color: ${props => (props.selected ? '#fff' : '#000')};
    @media (max-width: 1400px) {
      font-size: 18px;
      width: 246px;
    }
    @media (max-width: 1200px) {
      width: 300px;
      font-size: 20px;
    }
    @media (max-width: 730px) {
      font-size: 14px;
      font-style: normal;
      font-stretch: normal;
      margin-left: 10px;
      max-width: 60%;
    }
  }
  .placeName {
    align-items: center;
    display: flex;
    min-height: 38px;
    width: max-content;
    font-family: StolzlLight, serif;
    cursor: pointer;
    text-decoration: none;
    max-width: calc(100% - 10px);
    font-size: 18px;
    color: ${props => (props.selected ? '#fff' : '#000')};
    :hover {
      color: #933EC5;
    }
    @media (max-width: 1400px) {
      font-size: 16px;
    }
    @media (max-width: 1200px) {
      font-size: 18px;
    }
    @media (max-width: 500px) {
      font-size: 13px;
    }
  }
  .artistName { 
    width: max-content;
    text-transform: uppercase;
    max-width: calc(100% - 10px);
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 7px;
    cursor: pointer;
    text-decoration: none;
    color: ${props => (props.selected ? '#fff' : '#000')};
    :hover {
      color: #933EC5;
    }
    @media (max-width: 730px) {
      font-size: 16px;
      line-height: 1.25;
      letter-spacing: 2px;
    }
  }
  .time {
    width: max-content;
    margin-bottom: 13px;
  }
  .photo {
    object-fit: cover;
    border-radius: 6px;
    width: 100%;
    height: 100%;
    max-width: 110px;
    max-height: 110px;
    @media (max-width: 730px) {
      border-radius: 0;
      width: 100%;
      height: 100%;
      max-width: 130px;
      max-height: 130px;
    }
  }
`
